module.exports = __webpack_public_path__ + "img/logo.943fe2ea.png";